import { useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { selectPanicToken, selectPanicReason } from '~/components/account/reality-check/ducks/selectors.js';
import { hidePanicReason } from '~/components/account/reality-check/ducks/index.js';
import Icon, { ICON_PAUSE_ICON } from '~/components/icon/index.js';
import { HeadWrapper, MainTitle, SubTitle } from '../misc/section-head.js';
import { showNotification } from '../notifications/ducks/notifications.js';
import { postJson } from '../../core/ajax-json.js';
import ButtonWrapper from '../misc/button-wrapper.js';
import CheckBox from '../forms/checkbox';
import { Smaller, Bigger } from '../layout/mediaquery';
import { ModalView } from '../modal/modal.js';
import useTranslations from '../translation/use-translations';
import { useCloseAllContexts } from '../../hooks/use-close-context.js';

const PanicWrapperFull = styled.div`
	z-index: 40;
	padding-top: 28px;
	position: fixed;
`;

const PanicWrapper = styled.div`
	z-index: 40;
	padding-top: 28px;
`;

const PanicReasonModalView = styled(ModalView)`
	z-index: 40;
	width: 50%;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	height: auto;
`;

const ConfirmButtonWrapper = styled(ButtonWrapper)`
	padding: 12px;
`;

const TEXT_KEYS = [
	'MOBILE_PANIC_LOGGED_OUT',
	'MOBILE_PANIC_LOGGED_OUT_DESC',
	'MOBILE_SELECT_PANIC_REASON',
	'MOBILE_PANIC_LOGOUT_REASON_1',
	'MOBILE_PANIC_LOGOUT_REASON_2',
	'MOBILE_PANIC_LOGOUT_REASON_3',
	'MOBILE_PANIC_LOGOUT_REASON_4',
	'BUTTON_CLOSE',
	'MOBILE_PANIC_LOGOUT_NOTIFY_TEXT'
];

const OPTIONS = [
	'MOBILE_PANIC_LOGOUT_REASON_1',
	'MOBILE_PANIC_LOGOUT_REASON_2',
	'MOBILE_PANIC_LOGOUT_REASON_3',
	'MOBILE_PANIC_LOGOUT_REASON_4'
];

const PanicReason = () => {
	const panicToken = useSelector(selectPanicToken);

	const closeAllContexts = useCloseAllContexts();
	const dispatch = useDispatch();
	const [selectedOption, setSelectedOption] = useState(null);

	const { translations: tr, isLoadingTranslations } = useTranslations(TEXT_KEYS);

	const confirmReason = async () => {
		if (panicToken) {
			try {
				await postJson(`/player-account/panic-button-reason`, {
					token: panicToken,
					reason: selectedOption
				});
			} catch (error) {
				console.error(error); // eslint-disable-line
			}
		}
		closeAllContexts();
		dispatch(hidePanicReason());
		dispatch(
			showNotification({
				message: tr.MOBILE_PANIC_LOGOUT_NOTIFY_TEXT,
				color: 'neutral',
				autoHide: true,
				openInSidebar: false
			})
		);
	};

	if (isLoadingTranslations) return null;

	const content = (
		<>
			<div className="u-scroll-content-wrapper content">
				<HeadWrapper stickyHeader className="u-background--primary">
					<Icon type={ICON_PAUSE_ICON} />
					<MainTitle>{tr.MOBILE_PANIC_LOGGED_OUT}</MainTitle>
					<SubTitle className="panic-reason-desc">{tr.MOBILE_PANIC_LOGGED_OUT_DESC}</SubTitle>
				</HeadWrapper>
				<h2 className="u-mb1 u-pl1 panic-reason-select">{tr.MOBILE_SELECT_PANIC_REASON}</h2>
				<div className="list-options u-pl1 u-pr1 u-pb-xl">
					<ul className="custom-checkbox-list">
						{OPTIONS.map(option => (
							<li key={option.id} className="link-list__item">
								<CheckBox
									id={option}
									isChecked={selectedOption === option}
									onChange={() => setSelectedOption(option)}
									label={tr[option]}
									iconPosition="right"
								/>
							</li>
						))}
					</ul>
				</div>
			</div>
			<ConfirmButtonWrapper>
				<button
					data-at="account-panic-logout-reason-button"
					type="button"
					className="btn"
					data-message="{{#i18n}}BUTTON_CLOSE{{/i18n}}" // ??
					onClick={confirmReason}
					disabled={!selectedOption}
				>
					{tr.BUTTON_CLOSE}
				</button>
			</ConfirmButtonWrapper>
		</>
	);

	return (
		!isLoadingTranslations && (
			<>
				<Smaller>
					<PanicWrapperFull className="js-account-panic-logout modal-view account-panic-logout">
						{content}
					</PanicWrapperFull>
				</Smaller>
				<Bigger>
					<PanicReasonModalView>
						<PanicWrapper className="js-account-panic-logout account-panic-logout">{content}</PanicWrapper>
					</PanicReasonModalView>
				</Bigger>
			</>
		)
	);
};

const PanicReasonContainer = () => {
	const panicReason = useSelector(selectPanicReason);
	return panicReason && <PanicReason panicReason={panicReason} />;
};

export default PanicReasonContainer;
